import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { VIDEO_BASE_CLASSNAME } from './Constants';
import { createVideo } from './Video';
createComponents(".".concat(VIDEO_BASE_CLASSNAME), createVideo, NO_PATTERN_BUSINESS_LOGIC);
